export const leadsQueryBase = {
	_limit: '25',
	_sort: '-createdAt',
};

export const TABS = {
	OWN: 'own',
	OWNER: 'owner',
	ALL: 'all',
	ALL_ORGANIZATION: 'allOrganization',
};
